import {connectRouter} from 'connected-react-router';
import {History} from 'history';
import {combineReducers} from 'redux';

import globalReducer from '../state/global/reducer';
import media from '../state/media/reducer';
import polling from '../state/polling/reducer';
import reports from '../state/reports/reducer';
import runs from '../state/runs-low/reducer';
import sweeps from '../state/sweeps/reducer';
import viewer from '../state/viewer/reducer';
import views from '../state/views/reducer';
import workspaces from '../state/workspaces/reducer';
import auth from './auth';
import location from './location';
import report from './report';

export default (history: History) =>
  combineReducers({
    auth,
    global: globalReducer,
    media,
    location,
    router: connectRouter(history),
    report,
    views,
    workspaces,
    runs,
    polling,
    reports,
    sweeps,
    viewer,
  });
